import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Space, Popover, Badge } from 'antd';
import { Button } from 'witmeg-ui-system'
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import _ from "lodash";
import "@fontsource/inter";
import "@fontsource/jost";
import config from "react-global-configuration";
import './Navbar.scss';
import { useHistory } from 'react-router-dom';
import { getCompanyAllPagesInfo, updateOrderTypeDetails } from '../../../RestaurantWidget/utilities/api/restaurantsService';
import profile from "../../assets/solar_user-outline.svg"
import arrow from "../../assets/down-arrow.svg"
import menu from "../../assets/menu.svg"
import search from "../../assets/search-normal.svg"
import searchIc from "../../assets/search.svg"
import close from "../../assets/close.svg"
import loc from "../../assets/location-black.svg"

import { setOrderData, setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import { isECommerceProcessPath, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from '../../../RestaurantWidget/utilities/helper/helper';
import CartPopup from '../Cart/CartPopup';
const IMAGE_PLACEHOLDER = 'data:image/png;base64,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';
const Navbar = ({ setIsDrawerOpen, setAddDeliveryLoc, setCheckoutFailed }) => {
    const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes

    const orderTypes = [
        { name: "Collection", type: "collection", typeValue: "TAKE_AWAY" },
        // { name: "Dine-in", type: "table", typeValue: "DINE_IN" },
        { name: "Delivery", type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },

    ]
    const filteredData = orderTypes.filter(item => availableTypes?.includes(item.type));

    const dispatch = useDispatch()
    const { selectedOrderType } = useSelector((state) => state.resturantData);
    const data = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_ALL_MENU_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_ALL_MENU_DATA)).data : {}
    const [searchKey, setSearchKey] = useState('')
    const [items, setItems] = useState([])
    const history = useHistory()
    const [state, setState] = useState({
        menusize: 0,
        menus: "",
        pages: [],
        categories: [],
        brands: [],
        basketitem: [],
        // hasResturantWidget: null,
        cloudLocations: [],
        locationsDropdown: [],
        selectedLocation: {},
        visibleCartSummaryPopup: false,
        showDropdown: false,
        redirect: false,
        activeDropdown: null,

        locations: [],
        defaultLocation: {},

        updateCartItemPopup: {
            visible: false,
            data: null,
            index: null,
            editData: null,
        },
    });
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}


    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDataState = useSelector((state) => state.companyData);
    const resize = () => {
        if (window.innerWidth > 1681) {
            setState((prevState) => ({ ...prevState, menusize: 5 }));
        } else if (window.innerWidth < 1400 && window.innerWidth > 1150) {
            setState((prevState) => ({ ...prevState, menusize: 2 }));
        } else {
            setState((prevState) => ({ ...prevState, menusize: 3 }));
        }
    };
    const [isOpen, setIsOpen] = useState(false);
    const popoverRef = useRef(null);
    const containerRef = useRef(null);
    const togglePopover = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setSearchKey("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        window.addEventListener("resize", resize);
        resize();

        const _initData = async () => {
            const __response = await getCompanyAllPagesInfo({
                ID: "",
                CompanyID: config.get("companyID"),
            });

            let __pages = __response
                .filter((z) => z.DraftMainPagesInfoID === "")
                .map((y) => {
                    return {
                        ...y,
                        children: __response.filter(
                            (a) => a.DraftMainPagesInfoID === y.ID
                        ),
                    };
                });
            setState((prevState) => ({ ...prevState, pages: __pages }));
        };
        _initData();
    }, []);



    useEffect(() => {
        if (
            restaurantDataState.resturantCloudLocations &&
            restaurantDataState.resturantCloudLocations.length > 0 &&
            restaurantDataState.defualtSelectedLocation
        ) {
            const _locations = restaurantDataState.resturantCloudLocations.map(
                (__location) => ({
                    label: __location.CloudLocationName,
                    value: __location.CloudLocationID,
                })
            );

            const _defaultLocation = _.find(_locations, {
                value: restaurantDataState.defualtSelectedLocation
                    .CloudLocationID,
            });

            setState((prevState) => ({
                ...prevState,
                locations: _locations,
                defaultLocation: _defaultLocation,
                selectedLocation: _defaultLocation,
            }));
        }
    }, [
        restaurantDataState.resturantCloudLocations,
        restaurantDataState.defualtSelectedLocation,
    ]);

    useEffect(() => {
        if (companyDataState && companyDataState.companyDetails && companyDataState.companyDetails.organizationID) {
            axios.post(process.env.REACT_APP_TOKENSERVICE_URL, {
                isLoginServerRequest: false,
                serviceName: "productRegistry",
            }).then(async function (authresponse) {
                console.log("TOKEN response", authresponse)
                const requestOptions = {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authresponse.data.token}`,
                    }
                };

                let OrgID = companyDataState.companyDetails.organizationID

                axios.get(`${process.env.REACT_APP_rest_API_productregistry}/onlinecategories/${OrgID}`, requestOptions).then((categoryData) => {
                    if (categoryData.data.Status) {
                        console.log(categoryData.data.Result)
                    }
                })
            })
        }
    }, [companyDataState.companyDetails])

    useEffect(() => {
        if (data.Categories && data.Categories.length > 0) {
            let array = data.Categories.map((val) => {
                return val.MenuEntities.map((menuEntity) => {
                    const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                    return { ...menuItem, Category: val.Title.en };
                });
            }).flat();

            setItems(array)
        }
    }, [])
    useEffect(() => {
        if (data.Categories && data.Categories.length > 0) {
            let array = data.Categories.map((val) => {
                return val.MenuEntities.map((menuEntity) => {
                    const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                    return { ...menuItem, Category: val.Title.en };
                });
            }).flat();

            setItems(array)
        }
    }, [searchKey])
    const searchedItems = (searchingValue) => {
        return items.filter(item => item.Title && item.Title.en && item.Title.en.toLowerCase().includes(searchingValue.toLowerCase()));
    }
    const toggleCartSummaryPopover = () => {
        setState((prevState) => ({
            ...prevState,
            visibleCartSummaryPopup: !prevState.visibleCartSummaryPopup,
        }));
    };

    const changeUpdateCartItemPopupVisibility = (_visible, _data = null) => {
        if (_visible) {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: true,
                    data: _data.data,
                    editData: _data.editData,
                    index: _data.index,
                },
            }));
            toggleCartSummaryPopover();
        } else {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: false,
                    data: null,
                    editData: null,
                    index: null,
                },
            }));
        }
    };



    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/'
    };
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }

    return (
        <div className='Hospitality-navbar-Menu'>
            <div className="Hospitality-navbar-fixed-header">
                <Row align="middle">
                    <Col xs={5} className='Hospitality-navbar-menu-logo'>
                        <img
                            className="menu-icon-cont"
                            src={menu}
                            alt="Menu Icon"
                            onClick={() => {
                                if (window.screen.width > 600) {
                                    togglePopover()
                                } else {
                                    setIsDrawerOpen(true)
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <div className="popover" ref={popoverRef}>
                            {isOpen ? <div className={`popover-content`}>
                                <div className='track-order-ntag' onClick={() => {
                                    history.push("/")
                                    setIsOpen(false)
                                }}>Menu</div>
                                {!isECommerceProcessPath() &&
                                    state.pages.map((pn, index) => (
                                        <>
                                            {pn.children.length === 0 &&
                                                pn.ShowInMainMenu === true && (
                                                    <div key={index} className='track-order-ntag' onClick={() => {
                                                        history.push(`/pages/${pn.Slug}`)
                                                        setIsOpen(false)
                                                    }}>{pn.PageName}</div>

                                                )}
                                        </>
                                    ))
                                }
                                <div className='track-order-ntag' onClick={() => {
                                    history.push("/order/track")
                                    setIsOpen(false)
                                }}>Track your Order</div>
                                {localStorage.getItem('isLogged') === 'true' && <div className='track-order-ntag' onClick={() => {
                                    history.push("/order/history")
                                    setIsOpen(false)
                                }}>Order history</div>}

                            </div> : <div className='popover-content-close' />}
                        </div>
                        {/* <Drawer /> */}

                        <div className="Hospitality-navbar-logo">

                            <a
                                className="eco-navbar-logo"
                                href={!restaurantDataState.hasResturantWidget && `/`}
                            >
                                <img
                                    style={{ maxHeight: "48px" }}
                                    src={config.get("companyLogo")}
                                    draggable="false"
                                />
                            </a>
                        </div>
                        <Space className='Hospitality-navbar-menu-tab'>
                            <a href="/" style={{ color: "white" }}>Menu</a>
                            {!isECommerceProcessPath() &&
                                state.pages.map((pn, index) => (
                                    <>
                                        {pn.children.length === 0 &&
                                            pn.ShowInMainMenu === true && (
                                                <a
                                                    href={`/pages/${pn.Slug}`}
                                                    style={{ color: "white" }}
                                                >
                                                    {pn.PageName}
                                                </a>
                                            )}
                                    </>
                                ))
                            }
                        </Space>
                    </Col>

                    <Col xs={14} className='Hospitality-navbar-menu'>


                        {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : <Space className='Hospitality-navbar-menu-tab-right'>
                            {filteredData.map((orderType, index) => {
                                return (
                                    <div key={index} className={`Hospitality-navbar-menu-order-type ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-selected" : ""} `} onClick={() => {

                                        if (orderType.type === "delivery") {
                                            setAddDeliveryLoc(true)
                                        } else {
                                            const customerFormData = {
                                                ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                                Name: {
                                                    DisplayName: "",
                                                    FirstName: "",
                                                    LastName: "",
                                                },
                                                Email: "",
                                                Contact: {
                                                    Number: "",
                                                    PinCode: "+44",
                                                    CountryISO2: "GB"
                                                },
                                                BillingAddress: {
                                                    Id: "",
                                                    AddressType: "",
                                                    AddressLine1: "",
                                                    AddressLine2: "",
                                                    StateProvinceRegion: "",
                                                    PostZipCode: "",
                                                    Country: "",
                                                    CountryCode: "",
                                                    AddressLabel: "",
                                                    Longitude: 0,
                                                    Latitude: 0,
                                                    Additional: {
                                                        Instruction: "",
                                                        InteractionType: ""
                                                    }
                                                },
                                                DeliveryAddress: {
                                                    Id: "",
                                                    AddressType: "",
                                                    "AddressLine1": "",
                                                    "AddressLine2": "",
                                                    "City": "",
                                                    "StateProvinceRegion": "",
                                                    "PostZipCode": "",
                                                    "Country": "",
                                                    CountryCode: "",
                                                    AddressLabel: "",
                                                    Longitude: 0,
                                                    Latitude: 0,
                                                    Additional: {
                                                        Instruction: "",
                                                        InteractionType: ""
                                                    }
                                                },
                                            };
                                            let data = {
                                                "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                                "CompanyName": "",
                                                "UserName": "",
                                                "FirstName": "",
                                                "LastName": "",
                                                "Addresses": [
                                                    {
                                                        "AddressType": "Billing",
                                                        "HouseNo": "",
                                                        "AddressLine1": "",
                                                        "AddressLine2": "",
                                                        "City": "",
                                                        "StateProvinceRegion": "",
                                                        "PostZipCode": "",
                                                        "Country": "",
                                                        "Phone": "",
                                                        "Fax": "",
                                                        "Email": "",
                                                        "CreatedDate": "",
                                                        "LastModifiedDate": "",
                                                        "IsDefault": false,
                                                        "IsActive": false,
                                                        "TelephoneCode": "+44",
                                                        "AddressLabel": ""
                                                    },
                                                    {
                                                        "AddressType": "Delivery",
                                                        "HouseNo": "",
                                                        "AddressLine1": "",
                                                        "AddressLine2": "",
                                                        "City": "",
                                                        "StateProvinceRegion": "",
                                                        "PostZipCode": "",
                                                        "Country": "",
                                                        "Phone": "",
                                                        "Fax": "",
                                                        "Email": "",
                                                        "CreatedDate": "",
                                                        "LastModifiedDate": "",
                                                        "IsDefault": false,
                                                        "IsActive": false,
                                                        "TelephoneCode": "+44",
                                                        "AddressLabel": ""
                                                    }
                                                ],
                                                "Email": "",
                                            }
                                            localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                                            localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                            setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                                            dispatch(setSelectedOrderType(orderType.type))
                                            updateOrderType(orderType.typeValue)
                                        }


                                    }}>
                                        <div className={`menu-order-type-radio ${selectedOrderType === orderType.type ? "menu-order-type-radio-selected" : ""}`} >
                                            {selectedOrderType === orderType.type && <div className='menu-order-type-selected' />}
                                        </div>
                                        {orderType.name}</div>
                                )
                            })}
                            {selectedOrderType === "delivery" && <div className='location-delivery'
                                onClick={() => {
                                    setAddDeliveryLoc(true)
                                }}>
                                <img alt='' src={loc} />{customerDetails?.DeliveryAddress?.City}</div>}
                        </Space>}

                        {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ?
                            "" : <div className='search-wrapper-cont' ref={containerRef} >
                                <div className='search-container'>
                                    <img alt='' src={search} className='search-image' />
                                    <input className='search-input' placeholder='search' value={searchKey} onChange={e => { setSearchKey(e.target.value) }} />
                                    {searchKey !== "" && < img alt='' src={close} className='close-image' onClick={() => { setSearchKey("") }} />}
                                </div>
                                {searchKey !== "" &&
                                    <div className='searched-container'>
                                        {searchedItems(searchKey).length > 0 ? searchedItems(searchKey).map((value, index) => {
                                            return (
                                                <div key={index} className='searched-item-cont' onClick={() => {
                                                    localStorage.removeItem("QUANTITY")
                                                    localStorage.removeItem("ITEM")
                                                    history.push('/item/' + value.MenuItemID + "/" + "new")
                                                    setSearchKey("")
                                                }}>
                                                    <img style={{ objectFit: !value.ImageURL ? "fill" : "" }} alt='' className='searched-image-cont' src={value.ImageURL ? value.ImageURL : IMAGE_PLACEHOLDER} />
                                                    <div className='items-cont'>
                                                        <div className='searched-title'>
                                                            {value.Title.en}</div>
                                                        <div className='searched-cat'>{value.Category}</div></div></div>
                                            )
                                        }) : <div className='empty-search'>No results found for <b>{searchKey}</b></div>}</div>}
                            </div>
                        }
                    </Col>
                    <Col xs={5} className='Hospitality-navbar-user-prof'>
                        <Row>
                            <Col>
                                <Row align="middle">

                                    <Col className='Hospitality-navbar-sign-in-menu'>

                                        <div className='Hospitality-navbar-sign-in-menu-icon'>
                                            <img alt='' src={profile} className='Hospitality-navbar-sign-in-menu-icon-profile' />
                                        </div>
                                        <div>
                                            {localStorage.getItem('isLogged') === 'true' ?
                                                < >
                                                    <div className='my-account-text'>{JSON.parse(localStorage.getItem('fullUserDetails')).FirstName} {JSON.parse(localStorage.getItem('fullUserDetails')).LastName}</div>
                                                    <div className='log-text' onClick={handleLogout} style={{ color: "#55ccf6", cursor: "pointer" }}>Logout</div>
                                                </>
                                                :
                                                <>
                                                    <div className='my-account-text'>MY ACCOUNT</div>
                                                    <div className='log-text'>
                                                        <a href="/account/login" >Login</a>
                                                        <div className='border-line-sign' />
                                                        <a href="/account/register">Signup</a>
                                                    </div>
                                                </>

                                            }
                                        </div>

                                    </Col>
                                </Row>
                            </Col>

                            <Col className='Hospitality-navbar-order'>

                                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : < img className='searchIC' src={searchIc} onClick={() => {
                                    history.push("/item/search")
                                }} />}
                                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" :

                                    <Badge
                                        className="eco-navbar-toggle"
                                        count={
                                            restaurantDataState.cartDetails &&
                                                restaurantDataState.cartDetails.items
                                                ? restaurantDataState.cartDetails
                                                    .items.length
                                                : 100
                                        }
                                        size="small"
                                        overflowCount={99}
                                        style={{ transform: "translate(5%, -27%)", height: '18px', width: '18px' }}
                                    >
                                        <Popover
                                            content={
                                                <CartPopup
                                                    toggleVisibility={
                                                        toggleCartSummaryPopover
                                                    }
                                                    updateCartItemCallback={
                                                        changeUpdateCartItemPopupVisibility
                                                    }
                                                    websiteType={companyDataState.companyDetails.websiteType}
                                                    setCheckoutFailed={setCheckoutFailed}
                                                />
                                            }
                                            trigger="click"
                                            placement="bottomRight"
                                            visible={state.visibleCartSummaryPopup}
                                            onVisibleChange={() => {
                                                if (
                                                    state.visibleCartSummaryPopup ===
                                                    true
                                                ) {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        visibleCartSummaryPopup: false,
                                                    }));
                                                }
                                            }}
                                            overlayClassName="eco-order-summary eco-cart-summary"
                                        >
                                            <div className='Hospitality-navbar-cart-nav-item'>

                                                <div className='Hospitality-navbar-cart-icon' onClick={toggleCartSummaryPopover} >
                                                    <Button
                                                        category="icon"
                                                        variant="link"
                                                        children="cart"
                                                        color="white"

                                                    />
                                                    {restaurantDataState?.orderCartData?.Items && restaurantDataState?.orderCartData?.Items?.length > 0 && < div className='Hospitality-navbar-noti-item'>{restaurantDataState?.orderCartData?.Items?.length}</div>}
                                                </div>
                                                <div className='Hospitality-navbar-history-icon' onClick={() => {
                                                    // history.push("/order/track")
                                                }}><img alt='' src={arrow} className='Hospitality-navbar-history' /></div>

                                            </div>
                                        </Popover>
                                    </Badge>

                                }
                            </Col>
                        </Row>

                    </Col>
                </Row>

            </div >
            <div className='mob-order-selection'>
                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : <Space className='Hospitality-navbar-menu-mob'>
                    {filteredData.map((orderType, index) => {
                        return (
                            <div key={index} className={`Hospitality-navbar-menu-order-type-mob ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-mob-selected" : ""} `} onClick={() => {

                                if (orderType.type === "delivery") {
                                    setAddDeliveryLoc(true)
                                } else {
                                    const customerFormData = {
                                        ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                        Name: {
                                            DisplayName: "",
                                            FirstName: "",
                                            LastName: "",
                                        },
                                        Email: "",
                                        Contact: {
                                            Number: "",
                                            PinCode: "+44",
                                            CountryISO2: "GB"
                                        },
                                        BillingAddress: {
                                            Id: "",
                                            AddressType: "",
                                            AddressLine1: "",
                                            AddressLine2: "",
                                            StateProvinceRegion: "",
                                            PostZipCode: "",
                                            Country: "",
                                            CountryCode: "",
                                            AddressLabel: "",
                                            Longitude: 0,
                                            Latitude: 0,
                                            Additional: {
                                                Instruction: "",
                                                InteractionType: ""
                                            }
                                        },
                                        DeliveryAddress: {
                                            Id: "",
                                            AddressType: "",
                                            "AddressLine1": "",
                                            "AddressLine2": "",
                                            "City": "",
                                            "StateProvinceRegion": "",
                                            "PostZipCode": "",
                                            "Country": "",
                                            CountryCode: "",
                                            AddressLabel: "",
                                            Longitude: 0,
                                            Latitude: 0,
                                            Additional: {
                                                Instruction: "",
                                                InteractionType: ""
                                            }
                                        },
                                    };
                                    let data = {
                                        "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                        "CompanyName": "",
                                        "UserName": "",
                                        "FirstName": "",
                                        "LastName": "",
                                        "Addresses": [
                                            {
                                                "AddressType": "Billing",
                                                "HouseNo": "",
                                                "AddressLine1": "",
                                                "AddressLine2": "",
                                                "City": "",
                                                "StateProvinceRegion": "",
                                                "PostZipCode": "",
                                                "Country": "",
                                                "Phone": "",
                                                "Fax": "",
                                                "Email": "",
                                                "CreatedDate": "",
                                                "LastModifiedDate": "",
                                                "IsDefault": false,
                                                "IsActive": false,
                                                "TelephoneCode": "+44",
                                                "AddressLabel": ""
                                            },
                                            {
                                                "AddressType": "Delivery",
                                                "HouseNo": "",
                                                "AddressLine1": "",
                                                "AddressLine2": "",
                                                "City": "",
                                                "StateProvinceRegion": "",
                                                "PostZipCode": "",
                                                "Country": "",
                                                "Phone": "",
                                                "Fax": "",
                                                "Email": "",
                                                "CreatedDate": "",
                                                "LastModifiedDate": "",
                                                "IsDefault": false,
                                                "IsActive": false,
                                                "TelephoneCode": "+44",
                                                "AddressLabel": ""
                                            }
                                        ],
                                        "Email": "",
                                    }
                                    localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                                    localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                    setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                                    dispatch(setSelectedOrderType(orderType.type))
                                    updateOrderType(orderType.typeValue)
                                }
                            }}>
                                {orderType.name}</div>
                        )
                    })}
                </Space>}
                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType === "delivery" && <div className='location-delivery-mobile'
                    onClick={() => {
                        setAddDeliveryLoc(true)
                    }}>
                    <img alt='' src={loc} />{customerDetails?.DeliveryAddress?.City}</div>}
            </div>
        </div >
    );
};

export default Navbar;